import React from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import tracking from '../../utils/tracking';
import debounce from 'lodash/debounce';
import { NavLink } from 'react-router-dom';
import routes from '../../routes';
import './Header.scss';
import './PromoBar.scss';
import images from './images';

class Header extends React.Component {
	state = {
		menuOpen: false,
		navHeight: 0,
		journalAdded: 0,
		promoData: false
	};
	debouncedResize = null;
	moduleNames = [{ name: 'Navigation', title: 'Navigation' }];

	constructor(props) {
		super(props);
		this.fetchPromoData();
	}

	closeMenu = () => {
		this.setState({ menuOpen: false });
		document.body.style.overflow = 'scroll';
	};

	openMenu = () => {
		document.body.style.overflow = 'hidden';
		tracking.event('customEvent', {
			eventCategory: 'Navigation',
			eventAction: 'click',
			eventLabel: `Hamburger open, source: ${window.location.pathname}`
		});
		this.setState({ menuOpen: true });
	};

	onBookClick = url => {
		tracking.event('customEvent', {
			eventCategory: 'Nav Link',
			eventAction: 'click',
			eventLabel: `link: Book, source: ${window.location.pathname}`
		});
	};

	getRouteFromPath = path => {
		let index = -1;
		let routeFound = false;

		routes.some(route => {
			const isRoute = route.path.split('/')[1] === `${path.split('/')[1]}`;
			index += 1;
			if (isRoute) {
				routeFound = true;
			}

			return isRoute;
		});

		if (!routeFound) {
			return {};
		}

		return routes[index];
	};

	sortContents(contents) {
		if (!contents) {
			return { textLinks: [], ctaLinks: [] };
		}

		const textLinks = contents.Navigation[0].filter(
			item => item.title !== 'CTA'
		);
		const ctaLinks = contents.Navigation[0].filter(
			item => item.title === 'CTA'
		);

		return { textLinks, ctaLinks };
	}

	parseValue(value) {
		const result = /\[([^\]]+)]\(([^\)]+)\)/g.exec(value);

		if (!result) {
			return {
				title: value,
				url: 'https://www.opentable.ie/r/guinness-open-gate-brewery-reservations-dublin?restref=213819&lang=en-IE&ot_source=Restaurant%20website'
			};
		}
		const el = document.createElement('div');
		el.innerHTML = result[2];
		return { title: result[1], url: el.innerText };
	}

	renderLogo() {
		if (this.props.location.pathname === '/') {
			return (
				// Leave as link, not div - odd bug where when using div
				// clicking mobile menu nav link results in subsequent openMenu() call
				<a
					className="Header__nav-logo"
					href="/"
					id={`${this.state.menuOpen}____test`}
					style={{ position: this.state.menuOpen ? 'absolute' : '' }}
				>
					<img
						src={images.logo}
						className={this.props.showLogo ? 'Header__logo' : 'Header__logo Header__logo--hidden'}
						alt="Open Gate Brewery"
					/>
				</a>
			);
		}

		return (
			<NavLink
				className="Header__nav-logo"
				exact
				to="/"
				style={{ position: this.state.menuOpen ? 'absolute' : '' }}
				onClick={() =>
					tracking.event('customEvent', {
						eventCategory: 'Nav Link',
						eventAction: 'click',
						eventLabel: `link: Home, source: ${window.location.pathname}`
					})
				}
			>
				<img
					src={images.logo}
					className="Header__logo"
					alt="Open Gate Brewery"
				/>
			</NavLink>
		);
	}

	fetchPromoData = () => {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';
		axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/Promo Bar.json?v=${Math.random()}`)
			.then(response => {
				// this.data = response.data.contents[0].fields
				for (let field of response.data.contents[0].fields) {
					switch (field.id) {
						case 'copy':
							this.promoCopy = field.value;
							break;
						case 'buttoncopy':
							this.promoBtnCopy = field.value;
							break;
						case 'link':
							this.promoLink = field.value;
							break;
						case 'isactive':
							this.promoIsActive = field.value;
							break;
						default:
							break;
					}
				}
			})
			.then(() => {
				this.setState({ promoData: true });
			})
			.catch(error => {
				console.log('Error fetching and parsing data', error);
			});
	}

	componentDidMount() {
		if (!this.props.data.fetchedData) {
			this.props.fetchData(
				{
					name: 'navigation',
					modules: this.moduleNames,
					transform: false,
					moduleKey: 'NAVIGATION'
				},
				true,
				'OGB-CONTENT-NAVIGATION'
			);
		}
		else {
			console.log('Navigation - data fetched');
		}
	}

	componentDidUpdate() {
		if (this.state.promoData && this.promoIsActive === 'true') {
			let promoEl = document.getElementById('PromoBarWrap');
			let promoScrollHt = promoEl.scrollHeight;
			let navEl = document.getElementById('NavWrap');
			let container = document.getElementById('HeaderContainer');


			let debouncedResize = debounce(() => {
				let scroll = document.documentElement.scrollTop;
				if (window.innerWidth > 768) {
					promoEl.classList.remove('closed');
					if (scroll > 500) {
						promoEl.style.height = 0;
						container.style.height = `${navEl.clientHeight}px`;
					}
					else if (scroll <= 100) {
						promoEl.style.height = `${promoEl.scrollHeight}px`;
						container.style.height = `${navEl.clientHeight + promoEl.scrollHeight}px`;
					}
				}
				else if (promoEl.classList.contains('closed')) {
					promoEl.style.height = 0;
					container.style.height = `${navEl.clientHeight}px`;
				}
				else {
					promoEl.style.height = `${promoEl.scrollHeight}px`;
					container.style.height = `${navEl.clientHeight + promoEl.scrollHeight}px`;
				}
			}, 100);


			window.addEventListener('resize', debouncedResize);
			window.addEventListener('scroll', debouncedResize);
			window.addEventListener('load', debouncedResize);
			document.getElementById('PromoClose').addEventListener('click', this.closePromo);
		}
	}

	closePromo() {
		let promoEl = document.getElementById('PromoBarWrap');
		let navEl = document.getElementById('NavWrap');
		let container = document.getElementById('HeaderContainer');

		promoEl.style.height = 0;
		promoEl.classList.add('closed');
		container.style.height = `${navEl.clientHeight}px`;
	}

	render() {
		const { contents } = this.props.data;
		if (contents) {
			if (this.state.journalAdded === 0) {
				this.setState({ journalAdded: 1 });

				// // Add Comedy Club Nav | REMOVE AFTER EVENT FINISHES
				// contents.Navigation[0][1] = {
				//     alternateText: "",
				//     description: "",
				//     fieldType: "Plain Text",
				//     id: "comedy-club",
				//     limitCharacterCount: "False",
				//     matchSpecifyPattern: "False",
				//     placeholder: "",
				//     title: "Comedy Club",
				//     uniqueFields: "False",
				//     value: ""
				// }

				// Add Welcome Back Nav
				// contents.Navigation[0].splice(-2, 0, {
				// 	title: "WELCOME BACK",
				// 	alternateText: "",
				// 	description: "",
				// 	value: "",
				// 	placeholder: ""
				// });
			}
		}
		const sortedContents = this.sortContents(contents);

		return (
			<div id={'HeaderContainer'} className={'hdrContainer'}>
				<div id={'HeaderWrap'} className={'hdrWrap'}>
					{this.promoIsActive === 'true' && this.promoCopy &&
						<div id={'PromoBarWrap'} className={'promoBar'}>
							<div className={'promoBar__mobile-close-wrap'}>
								<div className={'promoBar__mobile-close'}>
									<img
										id={'PromoClose'}
										className="d-md-none"
										width="15"
										height="15"
										alt="Close"
										src={images.crossblk}
									/>
								</div>
							</div>
							{this.promoBtnCopy && this.promoLink ?
								<a className={'promoBar__link'} href={this.promoLink} target={'_blank'} rel="noreferrer">
									<div className={'promoBar__content'}>
										{this.promoCopy && <span className={'promoBar__copy'}>{this.promoCopy}</span>}
										{this.promoBtnCopy && <span className={'promoBar__cta'}>{this.promoBtnCopy}</span>}
									</div>
								</a> :
								<div className={'promoBar__content'}>
									{this.promoCopy && <span className={'promoBar__copy'}>{this.promoCopy}</span>}
									{this.promoBtnCopy && <span className={'promoBar__cta'}>{this.promoBtnCopy}</span>}
								</div>
							}
						</div>
					}
					<div id="NavWrap">
						<nav className={`Header${this.state.menuOpen ? '__open' : ''}`}>
							<a className="Header__skip-link" href="#HeaderContainer">Skip to content</a>
							{this.renderLogo()}
							<div
								className={`Header__links ${
									this.state.menuOpen ? 'Header__links--visible' : ''
								}`}
							>
								<img
									onClick={() => {
										tracking.event('customEvent', {
											eventCategory: 'Navigation',
											eventAction: 'click',
											eventLabel: `Hamburger close, source: ${
												window.location.pathname
											}`
										});
										this.closeMenu();
									}}
									className="Header__close d-block d-md-none"
									width="40"
									height="40"
									alt="Close"
									src={images.cross}
								/>

								<div className="Header__links-text">
									{/* Main links */}
									{sortedContents.textLinks.map((route, index) => (
										<NavLink
											className={`Header__nav-item Header__nav-item--${index + 1}`}
											to={`/${route.title.replace(/\s/g, '-').toLowerCase()}`}
											activeClassName="Header__nav-item--active"
											key={`url_${index}`}
											onClick={() => {
												document.body.style.overflow = 'scroll';
												tracking.event('customEvent', {
													eventCategory: 'Nav Link',
													eventAction: 'click',
													eventLabel: `link: ${route.title}, source: ${
														window.location.pathname
													}`
												});
												this.closeMenu();
											}}
										>
											<span className="nav-item__underline">{route.title}</span>
										</NavLink>
									))}
								</div>

								{sortedContents.ctaLinks.map((route, index) => {
									const parsedValue = this.parseValue(route.value);
									return (
										<a
											className="Header__book-cta cta"
											target="_blank"
											href={parsedValue.url}
											key={`cta-link_${index}`}
											onClick={evt => {
												document.body.style.overflow = 'scroll';
												this.onBookClick(evt.currentTarget.href || '', evt);
											}} rel="noreferrer"
										>
											{parsedValue.title}
										</a>
									);
								})}
							</div>

							<h4
								style={{ display: this.state.menuOpen ? 'none' : '' }}
								className="Header__title d-md-none"
							>
								{this.getRouteFromPath(window.location.pathname).mobileTitle}
							</h4>

							<div
								onClick={() => {
									this.openMenu();
								}}
								style={{ display: this.state.menuOpen ? 'none' : '' }}
								className={this.state.menuOpen ? 'none' : 'Header__hamburger d-inline-block d-md-none'}
							>
								<img
									src={images.hamburger}
									style={{ display: this.state.menuOpen ? 'none' : '' }}
									className="Header__hamburger-image"
									alt="Menu"
								/>
							</div>
						</nav>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js